export type CompanySelectOption = {
  uuid: string;
  name: string;
};

export type CompanyToneDto = {
  name: string;
  value: string;
  tone: string;
};

export type CompanyDto = {
  uuid: string;
  name: string;
  type: CompanySelectOption;
  businessName: string | null;
  firstName: string | null;
  paternalLastName: string | null;
  maternalLastName: string | null;
  rfc: string;
  curp: string | null;
  societyType: CompanySelectOption | null;
  notes: string | null;
  status: CompanyToneDto;
  createdAt?: string;
  updatedAt?: string;
};

export type CompanyRequest = {
  personTypeUuid: string;
  businessName: string | null;
  firstName: string | null;
  paternalLastName: string | null;
  maternalLastName: string | null;
  rfc: string;
  curp: string | null;
  societyTypeUuid: string | null;
  notes: string | null;
};

export type CompanyListQuery = {
  name?: string;
  rfc?: string;
  curp?: string;
  typeUuids?: string[];
  statusUuids?: string[];
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
};

export type CompanyListResult = {
  items: CompanyDto[];
  total: number;
};

export type CompanyFormSelects = {
  personTypes: CompanySelectOption[];
  societyTypes: CompanySelectOption[];
};

export type CompanyFilterSelects = {
  personTypes: CompanySelectOption[];
  statuses: CompanyToneDto[];
};

export type CompanyFileDto = {
  uuid: string;
  name: string;
  contentType: string;
  size: number;
  url: string;
};

export type CompanyLegalFormSelects = {
  issuerTypes: CompanySelectOption[];
  assemblyTypes: CompanySelectOption[];
  countries: CompanySelectOption[];
};

export type CompanyIncorporationDto = {
  uuid: string;
  constitutionDate: string;
  instrumentNumber: string;
  issuerType: CompanySelectOption;
  issuerName: string;
  country: CompanySelectOption;
  state: CompanySelectOption;
  municipality: CompanySelectOption;
  instrumentFile: CompanyFileDto | null;
  registryDate: string;
  registryFolio: string;
  registryFile: CompanyFileDto | null;
  notes: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type CompanyIncorporationRequest = {
  constitutionDate: string;
  instrumentNumber: string;
  issuerTypeUuid: string;
  issuerName: string;
  countryUuid: string;
  stateUuid: string;
  municipalityUuid: string;
  registryDate: string;
  registryFolio: string;
  notes: string | null;
};

export type CompanyAssemblyMinuteDto = {
  uuid: string;
  date: string;
  number: string;
  type: CompanySelectOption;
  issuerType: CompanySelectOption;
  issuerName: string;
  country: CompanySelectOption;
  state: CompanySelectOption;
  municipality: CompanySelectOption;
  matters: string[];
  instrumentFile: CompanyFileDto | null;
  registryDate: string;
  registryFolio: string;
  registryFile: CompanyFileDto | null;
  notes: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type CompanyAssemblyMinuteRequest = {
  date: string;
  number: string;
  typeUuid: string;
  issuerTypeUuid: string;
  issuerName: string;
  countryUuid: string;
  stateUuid: string;
  municipalityUuid: string;
  matters: string[];
  registryDate: string;
  registryFolio: string;
  notes: string | null;
};

export type CompanyAssemblyMinuteListQuery = {
  date?: string;
  number?: string;
  matters?: string;
  issuerName?: string;
  typeUuids?: string[];
  countryUuids?: string[];
  stateUuids?: string[];
  municipalityUuids?: string[];
  issuerTypeUuids?: string[];
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
};

export type CompanyAssemblyMinuteListResult = {
  items: CompanyAssemblyMinuteDto[];
  total: number;
};

export type CompanyAssemblyMinuteFilterSelects = {
  assemblyTypes: CompanySelectOption[];
  issuerTypes: CompanySelectOption[];
  countries: CompanySelectOption[];
  states: CompanySelectOption[];
  municipalities: CompanySelectOption[];
};

export type CompanyApiDownload = {
  blob: Blob;
  filename: string;
};

export type CompanyStatusLabel = 'Activo' | 'Inactivo';

export function companyStatusLabel(company: CompanyDto): CompanyStatusLabel {
  const normalized = company.status.name.trim().toLowerCase();
  return company.status.tone === 'danger' ||
    normalized === 'inactivo' ||
    normalized === 'inactive'
    ? 'Inactivo'
    : 'Activo';
}
